export default "__VITE_ASSET__BNp811wI__"